

















import { Mixins, Component, Prop, Watch, Model } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';

@Component
export default class AxTestDialog extends Mixins(AxPage) {
  sw = true;

  @Prop({ type: String, default: '1024' })
  width!: string;

  @Prop({ type: String, default: '600' })
  height!: string;

  @Watch('sw')
  onSwitchChanged() {
    this.$emit('changed', this.sw);
    console.log('changed');
  }

  showTestDialog() {
    this.showDialog({ type: 'AxTestDialog', props: {} });
  }
}
